// Ders bazlı özet kartlarını toparlayan ana indeks dosyası
export { turkceCards } from './turkce';
export { matematikCards } from './matematik';
export { fenCards } from './fen';
export { inkilapCards } from './inkilap';
export { ingilizceCards } from './ingilizce';
export { dinCards } from './din';

// Tüm kartları birleştiren ana dizi
import { turkceCards } from './turkce';
import { matematikCards } from './matematik';
import { fenCards } from './fen';
import { inkilapCards } from './inkilap';
import { ingilizceCards } from './ingilizce';
import { dinCards } from './din';

export const allSummaryCards = [
  ...turkceCards,
  ...matematikCards,
  ...fenCards,
  ...inkilapCards,
  ...ingilizceCards,
  ...dinCards
];